import { ReactNode, forwardRef } from 'react';

import { AiChatMessageRole, isAiChatAssistantRole } from '../../models/ai-chat-message';
import { AiChatFeedbackReaction } from '../../types';
import MarkdownMessageContent from './MarkdownMessageContent';
import { MessageBubbleBody, MessageBubbleRow } from './styles';

export interface MessageBubbleProps {
    variant: AiChatMessageRole;
    isSplitMode?: boolean;
    isFullWidth?: boolean;
    highlightReaction?: AiChatFeedbackReaction | null;
    children: ReactNode;
}

const MessageBubble = forwardRef<HTMLDivElement, MessageBubbleProps>(
    ({ variant, isSplitMode = false, isFullWidth = false, highlightReaction, children }, ref) => {
        const shouldRenderMarkdown = isAiChatAssistantRole(variant) && typeof children === 'string';

        return (
            <MessageBubbleRow ref={ref} variant={variant}>
                <MessageBubbleBody
                    variant={variant}
                    isSplitMode={isSplitMode}
                    isFullWidth={isFullWidth}
                    highlightReaction={highlightReaction}
                >
                    {shouldRenderMarkdown ? (
                        <MarkdownMessageContent>{children}</MarkdownMessageContent>
                    ) : (
                        children
                    )}
                </MessageBubbleBody>
            </MessageBubbleRow>
        );
    }
);

export default MessageBubble;
